/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var buttonDefaultProps = {
  block: false,
  disabled: false,
  ghost: false,
  loading: false,
  shape: "rectangle",
  size: "medium",
  type: "button",
  variant: "base"
};

export { buttonDefaultProps };
//# sourceMappingURL=defaultProps.js.map
